/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { KTSVG } from '../../../helpers'

type Props = {
  className: string
  color: string
  title: string
  label1: string
  label2: string
  label3: string
  label4: string
  titleLabel: string
  text1: string
  text2: string
  text3: string
  text4: string
  text5: string
  value1: string
  value2: string
  value3: string
  value4: string
  titleValue: string
  condition1: boolean
  condition2: boolean
  condition3: boolean
  condition4: boolean
  show1: boolean
  show2: boolean
  show3: boolean
  show4: boolean
  marginTop: string
  paddingMarginClasses: string
  showTitleTab: boolean
  icon1: string
  icon2: string
  icon3: string
  icon4: string
  hotelId: string,
  hotelName: string,
  latestPayrollReportId: number,
  setHotelID: (id: string) => {}
  setHotelName: (name: string) => {}


}

const MixedWidget1: React.FC<Props> = ({ className, color, title
  , titleLabel, label1, label2, label3, label4,
  text1, text2, text3, text4,
  titleValue, value1, value2, value3, value4,
  condition1, condition2, condition3, condition4,
  show1, show2, show3, show4, marginTop, paddingMarginClasses,
  showTitleTab,
  icon1, icon2, icon3, icon4,
  hotelId, hotelName, setHotelID, setHotelName, latestPayrollReportId


}) => {



  const history = useHistory();




  const setHotel = () => {
    setHotelID(hotelId)
    setHotelName(hotelName)

  }

  const onPayrollMPORClick = () => {
    if (latestPayrollReportId != 0) {
      setHotel()

      history.push(`/payrollReport/Details/${latestPayrollReportId}`)
    } else {
      toast.info('No report Found', { position: toast.POSITION.TOP_RIGHT });
    }


  }


  return (
    <div className={`card ${className}`}>
      {/* begin::Body */}
      <div className='card-body p-0'>
        {/* begin::Header */}
        {showTitleTab &&
          <div className={`px-9 pt-7 card-rounded h-275px w-100 bg-${color}`}>
            {/* begin::Heading */}
            <div className='d-flex flex-stack'>
              <h4 className='m-0 text-white fw-bold fs-3'>{title}</h4>

            </div>
            {/* end::Heading */}
            {/* begin::Balance */}
            <div className='d-flex text-center flex-column text-white pt-8'>
              <span className='fw-bold fs-7'>{titleLabel ? titleLabel : '--'}</span>
              <span className='fw-bolder fs-2x pt-1'>{titleValue ? titleValue : '--'}</span>
            </div>
            {/* end::Balance */}
          </div>
        }
        {/* end::Header */}
        {/* begin::Items */}
        <div
          className={`shadow-xs card-rounded position-relative z-index-1 bg-light-${color} ${paddingMarginClasses}`}
          style={{ marginTop: marginTop, cursor: 'pointer' }}

          onClick={onPayrollMPORClick}
        >
          <h5 className='m-1 p-1 text-muted'>PayrollReport MPOR</h5>
          {/* begin::Item */}
          {show1 &&
            <div className='d-flex align-items-center  m-3'>
              {/* begin::Symbol */}
              {/* <div className='symbol symbol-45px w-40px me-5'>
                <span className='symbol-label bg-lighten'> */}
              {/* <KTSVG path='/media/icons/duotune/maps/map004.svg' className='svg-icon-1' /> */}
              {/* <KTSVG path={icon1 ? icon1 : '/media/icons/duotune/maps/map004.svg'} className='svg-icon-1' />
                </span>
              </div> */}
              {/* end::Symbol */}
              {/* begin::Description */}
              {/* replaced flex-wrap with flex-wrap  in 4 places*/}
              <div className='d-flex  justify-content-center flex-wrap w-100'>
                {/* begin::Title */}
                <div className='mb-1 pe-3 flex-grow-1'>
                  <a  className='fs-5 text-gray-800 text-hover-primary fw-bolder'>
                    {label1 ? label1 : '--'}
                  </a>
                  <div className='text-gray-400 fw-bold fs-7'>{label1 ? text1 : '--'}</div>
                </div>
                {/* end::Title */}
                {/* begin::Label */}
                <div className='d-flex align-items-center '>
                  <div className='fw-bolder fs-5 text-gray-800 pe-1'>{value1 ? value1 : '0'}</div>
                  {/* <KTSVG
                    path='/media/icons/duotune/arrows/arr066.svg'
                    className='svg-icon-1 svg-icon-success ms-1'
                  /> */}
                </div>
                {/* end::Label */}
              </div>
              {/* end::Description */}
            </div>
          }
          {/* end::Item */}
          {/* begin::Item */}
          {show2 &&
            <div className='d-flex align-items-center  m-3'>
              {/* begin::Symbol */}
              {/* <div className='symbol symbol-45px w-40px me-5'>
                <span className='symbol-label bg-lighten'> */}
              {/* <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-1' /> */}
              {/* <KTSVG path={icon2 ? icon2 : '/media/icons/duotune/general/gen024.svg'} className='svg-icon-1' />
                </span>
              </div> */}
              {/* end::Symbol */}
              {/* begin::Description */}
              <div className='d-flex justify-content-center flex-wrap w-100'>
                {/* begin::Title */}
                <div className='mb-1 pe-3 flex-grow-1'>
                  <a  className='fs-5 text-gray-800 text-hover-primary fw-bolder'>
                    {label2 ? label2 : '--'}
                  </a>
                  <div className='text-gray-400 fw-bold fs-7'>{label2 ? text2 : '--'}</div>
                </div>
                {/* end::Title */}
                {/* begin::Label */}
                <div className='d-flex align-items-center'>
                  <div className='fw-bolder fs-5 text-gray-800 pe-1'>{value2 ? value2 : '0'}</div>
                  {/* <KTSVG
                    path='/media/icons/duotune/general/gen024.svg'
                    className='svg-icon-1 svg-icon-danger ms-1'
                  /> */}
                </div>
                {/* end::Label */}
              </div>
              {/* end::Description */}
            </div>
          }
          {/* end::Item */}
          {/* begin::Item */}
          {show3 &&
            <div className='d-flex align-items-center  m-3'>
              {/* begin::Symbol */}
              {/* <div className='symbol symbol-45px w-40px me-5'>
                <span className='symbol-label bg-lighten'>
                  <KTSVG path={icon3  ? icon3 : '/media/icons/duotune/electronics/elc005.svg'} className='svg-icon-1' />
               
                </span>
              </div> */}
              {/* end::Symbol */}
              {/* begin::Description */}
              <div className='d-flex justify-content-center flex-wrap w-100'>
                {/* begin::Title */}
                <div className='mb-1 pe-3 flex-grow-1'>
                  <a  className='fs-5 text-gray-800 text-hover-primary fw-bolder'>
                    {label3 ? label3 : '--'}
                  </a>
                  <div className='text-gray-400 fw-bold fs-7'>{label3 ? text3 : '--'}</div>
                </div>
                {/* end::Title */}
                {/* begin::Label */}
                <div className='d-flex align-items-center'>
                  <div className='fw-bolder fs-5 text-gray-800 pe-1'>{value3 ? value3 : '0'}</div>
                  {/* <KTSVG
                    path='/media/icons/duotune/arrows/arr066.svg'
                    className='svg-icon-1 svg-icon-success ms-1'
                  /> */}
                </div>
                {/* end::Label */}
              </div>
              {/* end::Description */}
            </div>
          }
          {/* end::Item */}
          {/* begin::Item */}
          {show4 &&

            <div className='d-flex align-items-center'>
              {/* begin::Symbol */}
              <div className='symbol symbol-45px w-40px me-5'>
                <span className='symbol-label bg-lighten'>
                  {/* <KTSVG path='/media/icons/duotune/general/gen005.svg' className='svg-icon-1' /> */}
                  <KTSVG path={icon4 ? icon4 : '/media/icons/duotune/general/gen005.svg'} className='svg-icon-1' />

                </span>
              </div>
              {/* end::Symbol */}
              {/* begin::Description */}
              <div className='d-flex align-items-center flex-wrap w-100'>
                {/* begin::Title */}
                <div className='mb-1 pe-3 flex-grow-1'>
                  <a  className='fs-5 text-gray-800 text-hover-primary fw-bolder'>
                    {label4}
                  </a>
                  <div className='text-gray-400 fw-bold fs-7'>{text4}</div>
                </div>
                {/* end::Title */}
                {/* begin::Label */}
                <div className='d-flex align-items-center'>
                  <div className='fw-bolder fs-5 text-gray-800 pe-1'>{value4}</div>
                  <KTSVG
                    path='/media/icons/duotune/arrows/arr065.svg'
                    className='svg-icon-1 svg-icon-danger ms-1'
                  />
                </div>
                {/* end::Label */}
              </div>
              {/* end::Description */}
            </div>
          }
          {/* end::Item */}
        </div>
        {/* end::Items */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export { MixedWidget1 }
